import { useEffect } from 'react'
import { NavLink, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ArrowLeftCircle } from 'lucide-react'
import ROUTES from '@/routes/routes'
import { AppDispatch, RootState } from '@/redux/store'
import { getRoomDetails } from '@/redux/asyncThunks/room'
import { GameRoomStatus } from '@/redux/types/room'
import { UserRole } from '@/constants/room'
import RoomNotFound from '@/components/PageNotFound/RoomNotFound'
import UsageStatsPanel from '@/components/ChatAnalysis/UsageStatsPanel'

const GameSummary: React.FC = () => {
  const { roomId = '' } = useParams()
  const dispatch = useDispatch<AppDispatch>()

  const { currentRoom, error } = useSelector((state: RootState) => state.room)
  const userRole = useSelector((state: RootState) => state.user.user?.role)

  useEffect(() => {
    if (roomId) {
      dispatch(getRoomDetails(roomId))
    }
  }, [dispatch, roomId])

  if (!currentRoom) {
    return null
  }

  const isGameCompleted = currentRoom.status === GameRoomStatus.COMPLETED
  const isProfessor = userRole === UserRole.Professor

  if (error) {
    return <RoomNotFound message='Unable to fetch the room.' />
  }

  return (
    <div className='h-full flex flex-col'>
      <div className='w-full px-24 py-5'>
        <div className='flex items-center gap-x-2'>
          <NavLink
            to={ROUTES.PROFESSOR.ROOM_DETAILS(roomId)}
            className='flex-shrink-0'
          >
            <ArrowLeftCircle className='text-dark-blue hover:text-dark-blue-hovered' />
          </NavLink>
          <div>
            <h1 className='text-2xl font-bold text-dark-blue'>Game Summary</h1>
          </div>
        </div>
      </div>
      <div className='flex-1 overflow-auto px-24 pb-5'>
        {isGameCompleted && isProfessor ? (
          <UsageStatsPanel />
        ) : (
          <div className='space-y-3'>
            {!isProfessor && (
              <p className='text-lg text-black'>
                Only professors can access game summary.
              </p>
            )}
            {!isGameCompleted && (
              <p className='text-lg text-black'>
                Game summary is only available for completed games.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default GameSummary
